import InjectImages from "./injectImages";

export default InjectImages;
